import { SortAndPage } from "@/models/ui/sortAndPage";
import {
  ListReceiptPlanResponse,
  ListReceiptPlanResponseModelSchema,
  ReceiptPlanModelV2,
} from "./types";
import { http } from "../api_v2";

/**
 * Returns a list of the receipt plans linked to a plan, includes the
 * child tank plans.
 *
 * @param planId The id of the plan to fetch data for.
 * @param pagination Pagination, filtering etc.
 * @returns A list of all the plans matching the plan id and other filters, with pagination.
 */
async function listReceiptPlans(
  planId: number,
  pagination: SortAndPage = {},
): Promise<ListReceiptPlanResponse> {
  const planResponse = await http.get(`/plans/${planId}/receipt-plans`, {
    params: {
      offset: pagination.offset,
      limit: pagination.limit,
      sortBy: pagination.sortBy,
      sortDirection: pagination.sortDirection,
      filter: pagination.search,
    },
  });
  return ListReceiptPlanResponseModelSchema.parse(planResponse.data);
}

/**
 * Updates the receipt plans linked to a plan. Takes a list, which will
 * set the final list in the server. Replacing any existing plans.
 *
 * Note: You can't change the number of linked tank plans or receipt plans, only update the
 * existing ones.
 *
 * @param planId The plan ID of the plan to update.
 * @param plans All linked receipt plans associated with this discharge plan.
 */
async function updateReceiptPlans(planId: number, plans: ReceiptPlanModelV2[]) {
  await http.put(`/plans/${planId}/receipt-plans`, {
    planId: planId,
    plans: plans,
  });
}

export default { listReceiptPlans, updateReceiptPlans };
